var _jsxFileName = "/codebuild/output/src1744610141/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/auth/ForgotPassword/index.tsx";
import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { Button, InformationalScreen, LoadingModal, Stack, Text } from '@adc/parallax-component-library';
import { ApiStatus, ErrorCode } from 'Constants';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useApiError, useAuth } from 'Hooks';
import { Footer, FormContainer, Input, MainContainer, TopHeaderBackArrow } from 'Components/utility';
import { notifyApp } from 'Utilities/appCommunicator';
import i18n from 'Utilities/i18n';
import * as log from 'Utilities/log';
import mediator from 'Utilities/mediator';
import { getAuthSession } from 'Utilities/session';
import { forgotPass } from 'Services/auth';
const initialValuesFormik = {
  email: ''
};
const mapStateToProps = ({
  env: {
    osType,
    osVersion,
    app,
    appVersion
  }
}) => {
  return {
    osType,
    osVersion,
    app,
    appVersion
  };
};
const connector = connect(mapStateToProps);
const ForgotPasswordPage = ({
  osType,
  osVersion,
  app,
  appVersion
}) => {
  const [pageIndex, setPageIndex] = useState(0);
  const {
    showApiErrorModal,
    showNetworkErrorModal
  } = useApiError();
  const {
    handleWrongRegionError,
    showHcpError,
    showForgotPasswordBlockedMessage,
    showForgotPasswordConfirmationMessage,
    showCountryNotSupportedError,
    showCountryRegionError,
    showAppUpgradeError
  } = useAuth();
  const validationSchema = Yup.object().shape({
    email: Yup.string().email(i18n.t('ForgotPassword.content.forgotPasswordForm.formField.email.errors.emailAddressValidEmail')).required(i18n.t('ForgotPassword.content.forgotPasswordForm.formField.email.errors.required'))
  });
  const handleApiRequestError = useCallback((error, retryRequest) => {
    switch (error.status) {
      case ApiStatus.FORBIDDEN:
        {
          var _error$response;
          const code = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data.code;
          if (code === ApiStatus.FORBIDDEN_HCP_ACCOUNT) {
            showHcpError();
          }
          break;
        }
      case ApiStatus.BAD_REQUEST:
        {
          var _error$response2;
          const code = (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data.code;

          // Separate the error handling for LLU specifically, remove this if statement is Libre will follow the same error handling
          if (app === 'llu') {
            if (code === ApiStatus.WRONG_REGION) {
              handleWrongRegionError(error, showApiErrorModal, retryRequest);
              return;
            }
            if (code === ApiStatus.UNSUPPORTED_COUNTRY) {
              showCountryNotSupportedError();
              return;
            }
          }
          if (code === ApiStatus.UNSUPPORTED_COUNTRY || code === ApiStatus.WRONG_REGION) {
            showCountryRegionError();
            return;
          }
          break;
        }
      case ApiStatus.TOO_MANY_REQUESTS:
        showForgotPasswordBlockedMessage();
        break;
      case ApiStatus.UPGRADE_REQUIRED:
        {
          // Remove this if statement when Libre follows the same error handling
          if (app === 'llu') {
            showAppUpgradeError();
          }
          break;
        }
      default:
        error.code === ErrorCode.NETWORK_ERROR ? showNetworkErrorModal() : showApiErrorModal();
    }
  }, [app, handleWrongRegionError, showApiErrorModal, showAppUpgradeError, showCountryNotSupportedError, showCountryRegionError, showForgotPasswordBlockedMessage, showHcpError, showNetworkErrorModal]);
  const handleSubmitForgotPass = useCallback((email, retrySubmit) => {
    return new Promise((resolve, reject) => {
      forgotPass(email, osType, osVersion, app, appVersion).then(resolve).catch(error => {
        handleApiRequestError(error, retrySubmit);
        reject(error);
      });
    });
  }, [osType, osVersion, app, appVersion, handleApiRequestError]);
  const onSubmitForm = useCallback(async (values, {
    setSubmitting,
    submitForm
  }) => {
    setSubmitting(true);
    try {
      await handleSubmitForgotPass(values.email, submitForm);
      setPageIndex(1);
    } catch (err) {
      log.error(err);
    } finally {
      setSubmitting(false);
    }
  }, [handleSubmitForgotPass]);
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    isValid,
    isSubmitting,
    errors,
    touched,
    values
  } = useFormik({
    initialValues: initialValuesFormik,
    validationSchema,
    onSubmit: onSubmitForm,
    validateOnBlur: true
  });
  const handleResendEmail = () => {
    handleSubmitForgotPass(values.email, handleSubmit).then(showForgotPasswordConfirmationMessage).catch(err => {
      log.error(err);
    });
  };
  const handleClickDone = () => {
    if (getAuthSession()) {
      notifyApp('adc-webview:navigate-back-app');
      return;
    }
    mediator.publish('router:navigate', '/login');
  };
  const handleClickBack = () => {
    if (pageIndex === 1) {
      setPageIndex(0);
      return;
    }
    mediator.publish('router:back');
  };
  return /*#__PURE__*/React.createElement(MainContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 210,
      columnNumber: 5
    }
  }, isSubmitting && /*#__PURE__*/React.createElement(LoadingModal, {
    "aria-label": "Loading content",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 211,
      columnNumber: 24
    }
  }), /*#__PURE__*/React.createElement(InformationalScreen, {
    index: pageIndex,
    testID: "ForgotPassword",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 212,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Page, {
    topNavigationProps: {
      title: i18n.t('ForgotPassword.modals.322.title'),
      buttonStart: {
        element: /*#__PURE__*/React.createElement(TopHeaderBackArrow, {
          testID: "ForgotPass.step1-go-back",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 217,
            columnNumber: 24
          }
        }),
        label: 'ForgotPass.step1-go-back',
        onPress: handleClickBack
      }
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 213,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Content, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 223,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "ForgotPassword.subtitle",
    nativeID: "ForgotPassword.subtitle",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 224,
      columnNumber: 13
    }
  }, i18n.t('ForgotPassword.subtitle')), /*#__PURE__*/React.createElement(FormContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 227,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('ForgotPassword.content.forgotPasswordForm.formField.email.label'),
    placeholder: i18n.t('ForgotPassword.content.forgotPasswordForm.formField.email.placeholder'),
    label: i18n.t('ForgotPassword.content.forgotPasswordForm.formField.email.label'),
    errorMessage: errors.email,
    isInvalid: errors.email && touched.email ? true : false,
    testID: "email",
    value: values.email,
    marginTop: "$4",
    onChangeText: handleChange('email'),
    onBlur: handleBlur('email'),
    inputMode: "email",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 228,
      columnNumber: 15
    }
  }))), /*#__PURE__*/React.createElement(InformationalScreen.Footer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 249,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Footer, {
    buttonLabel: i18n.t('ForgotPassword.content.forgotPasswordForm.links.sendToEmail.label'),
    onButtonPress: handleSubmit,
    buttonTestID: "ForgotPass.sendLinkToEmail",
    disabled: !values.email || !isValid || isSubmitting,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 250,
      columnNumber: 13
    }
  }))), /*#__PURE__*/React.createElement(InformationalScreen.Page, {
    topNavigationProps: {
      title: i18n.t('CheckYourEmail.modals.322.title'),
      buttonStart: {
        element: /*#__PURE__*/React.createElement(TopHeaderBackArrow, {
          testID: "ForgotPass.step2-go-back",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 265,
            columnNumber: 24
          }
        }),
        label: 'ForgotPass.step2-go-back',
        onPress: handleClickBack
      }
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 261,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Content, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 271,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "ForgotPass.instructionsResetSendTo",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 272,
      columnNumber: 13
    }
  }, i18n.t('CheckYourEmail.subtitle')), /*#__PURE__*/React.createElement(Text, {
    style: {
      wordBreak: 'break-word'
    },
    type: "$bodyBase.strong",
    testID: "ForgotPassword.user-email",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 275,
      columnNumber: 13
    }
  }, values.email), /*#__PURE__*/React.createElement("img", {
    src: i18n.t('CheckYourEmail.content.checkYourEmail.media.checkYourEmail'),
    alt: "",
    style: {
      objectFit: 'contain',
      height: 190
    },
    id: "ForgotPassword.check-email-img",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 284,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    gap: 6,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 293,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Text, {
    marginTop: "$4",
    textAlign: "center",
    testID: "ForgotPassword.notReceiveEmail",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 294,
      columnNumber: 15
    }
  }, i18n.t('CheckYourEmail.content.checkYourEmail.primaryText')), /*#__PURE__*/React.createElement(Stack, {
    flexDirection: "row",
    justifyContent: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 297,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    label: i18n.t('CheckYourEmail.content.checkYourEmail.links.resendEmail.label'),
    "aria-label": i18n.t('CheckYourEmail.content.checkYourEmail.links.resendEmail.label'),
    onPress: handleResendEmail,
    testID: "ForgotPassword.resendEmail-btn",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 298,
      columnNumber: 17
    }
  })))), /*#__PURE__*/React.createElement(InformationalScreen.Footer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 312,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Footer, {
    buttonLabel: i18n.t('CheckYourEmail.content.checkYourEmail.links.done.label'),
    onButtonPress: handleClickDone,
    buttonTestID: "ForgotPassword.done-btn",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 313,
      columnNumber: 13
    }
  })))));
};
export default connector(ForgotPasswordPage);